import { render, staticRenderFns } from "./PhotoBooth.vue?vue&type=template&id=41c00bfd&scoped=true"
import script from "./PhotoBooth.vue?vue&type=script&lang=js"
export * from "./PhotoBooth.vue?vue&type=script&lang=js"
import style0 from "./PhotoBooth.vue?vue&type=style&index=0&id=41c00bfd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41c00bfd",
  null
  
)

export default component.exports